import { Menu } from 'antd';
import '../../assets/style.css'
import { Link, useLocation } from 'react-router-dom'
import logo from './assets/logo2.png'
import { UserOutlined, ToolOutlined, RetweetOutlined,
            AppstoreOutlined, PlusSquareOutlined,
            ArrowLeftOutlined, DollarCircleOutlined,
            TransactionOutlined, ArrowRightOutlined, InteractionOutlined,
            SettingFilled,
            UserSwitchOutlined, UsergroupAddOutlined, ExportOutlined,
            SwapOutlined,VerticalAlignMiddleOutlined,DragOutlined,RotateLeftOutlined
        }
from '@ant-design/icons';
import React, { useState } from 'react';

import { PRIMARY_COLOR } from '../../utils/constants'
import { isAgent } from '../constants/access'

const PATH_TO_KEY: Record<string, string> = {
    '/clients': '1',
    '/depot': '2',
    '/retrait': '3',
    '/benefices': '4',
    '/rapports/credits': '11',
    '/rapports/clients/hors-bureau': '112',
    '/rapports/soldes-bureau': '111',
    '/utilisateurs': '6',
    '/devises': '7',
    '/taux-jours': '8',
    '/depenses': '9',
    '/inject-fond': '99',
    '/comptes-globales': '10',
};

export default function Index() {
    const location = useLocation();
    const pathname = location.pathname.length > 1 ? location.pathname.replace(/\/+$/, '') : location.pathname;
    const selectedKey = PATH_TO_KEY[pathname];
    const [openKeys, setOpenKeys] = useState<string[]>(['sub1']);

    const onOpenChange = (keys: string[]) => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    };

    const menuLabel = (text: string) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', maxWidth: 130 }}>
            {text}
        </span>
    );

    const items = [
        {
            key: 'sub1',
            icon: <UsergroupAddOutlined />,
            label: menuLabel('Opérations Client'),
            style: { backgroundColor: PRIMARY_COLOR },
            children: [
                { key: '1', icon: <UserSwitchOutlined />, label: <Link to="/clients">Clients</Link> },
                { key: '2', icon: <ExportOutlined />, label: <Link to="/depot">Dépot</Link> },
                { key: '3', icon: <InteractionOutlined />, label: <Link to="/retrait">Rétrait</Link> },
            ],
        },
        {
            key: 'sub4',
            icon: <RetweetOutlined />,
            label: menuLabel('Rapports'),
            children: [
                { key: '11', icon: <RotateLeftOutlined />, label: <Link to="/rapports/credits">Crédits</Link> },
                { key: '112', icon: <DragOutlined />, label: <Link to="/rapports/clients/hors-bureau">Transactions</Link> },
                // Solde Bureau désactivé : le module dépôt/retrait n'alimente que le compte global (voir "Soldes" ci-dessous)
                // { key: '111', icon: <DollarCircleOutlined />, label: <Link to="/rapports/soldes-bureau">Soldes Bureau</Link> },
                { key: '4', icon: <DollarCircleOutlined />, label: <Link to="/benefices">Bénéfices</Link> },
                { key: '10', icon: <DollarCircleOutlined />, label: <Link to="/comptes-globales">Soldes</Link> },
            ],
        },
        {
            key: 'sub3',
            icon: <SettingFilled />,
            label: menuLabel('Parametres'),
            children: [
                { key: '6', icon: <UserOutlined />, label: <Link to="/utilisateurs">Utilisateurs</Link> },
                { key: '7', icon: <TransactionOutlined />, label: <Link to="/devises">Devises</Link> },
                { key: '8', icon: <ToolOutlined />, label: <Link to="/taux-jours">Taux du jour</Link> },
                { key: '9', icon: <AppstoreOutlined />, label: <Link to="/depenses">Depenses</Link> },
                { key: '99', icon: <PlusSquareOutlined />, label: <Link to="/inject-fond">Injecter fond</Link> },
            ],
        },
    ];

    // L'agent voit tout le menu comme l'admin, sauf le sous-menu Utilisateurs.
    const visibleItems = isAgent()
        ? items.map(item => item.key === 'sub3'
            ? { ...item, children: item.children.filter(child => child.key !== '6') }
            : item)
        : items;

    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.1)',
                margin: '12px',
                borderRadius: 6,
            }}>
                <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <img src={logo} alt="logo" style={{ height: 32, width: 32, objectFit: 'contain', flexShrink: 0 }} />
                    <span style={{ color: '#fff', fontSize: 16, fontWeight: 600, whiteSpace: 'nowrap' }}>B-Transfert</span>
                </Link>
            </div>
            <Menu
                style={{ backgroundColor: PRIMARY_COLOR }}
                theme="dark"
                mode="inline"
                selectedKeys={selectedKey ? [selectedKey] : []}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                items={visibleItems}
            />
        </>
    );
}
